import React from "react";
import LaterPaymentCheckout from "~/components/laterPaymentCheckout";

const LaterPaymentCheckoutPage = (props) => <LaterPaymentCheckout {...props} />;

export default LaterPaymentCheckoutPage;
